var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink2Diagonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.42 7.33064L6.52046 17.2301C5.73942 18.0112 4.47309 18.0112 3.69204 17.2301C2.91099 16.4491 2.91099 15.1828 3.69204 14.4017L13.238 4.85577C14.8001 3.29367 17.3327 3.29367 18.8948 4.85577C20.4569 6.41787 20.4569 8.95053 18.8948 10.5126L12.5309 16.8766",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2Diagonal);
export default __webpack_public_path__ + "static/media/link-2-diagonal.4e7a4e1741bf037e0214e6dba231da8b.svg";
export { ForwardRef as ReactComponent };